import { Blueprint } from '../../blueprint.class';
import { ToolResult } from '../../types';
import { kitchenShapes, ShapeGroup } from '../../../kitchens/data';

export interface GetLayoutOptionsArgs {
	groupKey?: string;
}

export const getLayoutOptionsTool = (_blueprint: Blueprint, { groupKey }: GetLayoutOptionsArgs): ToolResult<ShapeGroup[]> => {
	const layouts = Object.values(kitchenShapes);

	if (groupKey) {
		const filtered = layouts.filter((layout) => layout.key === groupKey);
		if (filtered.length === 0) {
			return { success: false, error: `Layout group '${groupKey}' not found. Available groups: ${Object.keys(kitchenShapes).join(', ')}` };
		}
		return {
			success: true,
			message: `Found ${filtered.length} layout group(s).`,
			data: filtered
		};
	}

	return {
		success: true,
		message: `Found ${layouts.length} layout groups with ${layouts.reduce((acc, l) => acc + l.options.length, 0)} total options.`,
		data: layouts
	};
};
